import { post } from './http';
import * as gtmService from './Gtm.service';

export const add = async ({ articleNumber, quantity = 1, note = null }) => {
  if (!quantity || isNaN(quantity) || parseFloat(quantity) <= 0) {
    throw 'Invalid quantity';
  }

  const response = await post('/api/cart/add', {
    articleNumber,
    quantity: parseFloat(quantity),
    note,
  });

  const json = await response.json();

  let product = {};
  Object.keys(json.orderRows).map((rowGroupKey) =>
    json.orderRows[rowGroupKey].map((row) => {
      if (row.articleNumber == articleNumber) {
        product = row;
      }
    })
  );

  try {
    if (product && product.gtmProduct) {
      product.gtmProduct.quantity = parseInt(quantity);
      gtmService.pushEcommerce({
        event: 'productImpressions',
        ecommerce: {
          currencyCode: product.currency,
          add: {
            products: [product.gtmProduct],
          },
        },
      });
    }
    if (product && product.gtmEcommerceItem) {
      product.gtmEcommerceItem.quantity = parseInt(quantity);
      gtmService.dataLayerAddToCart([product.gtmEcommerceItem]);
    }
  } catch (error) {
    console.log('error', error);
  }

  return json;
};

export const addMultiple = async (products) => {
  if (
    products.filter(
      (p) => !p.quantity || isNaN(p.quantity) || parseInt(p.quantity) <= 0
    ).length > 0
  ) {
    throw 'Invalid quantity';
  }

  const response = await post(
    '/api/cart/addMultiple',
    products.map((product) => {
      return {
        articleNumber: product.articleNumber,
        quantity: parseInt(product.quantity),
      };
    })
  );

  const json = await response.json();

  try {
    let responseProducts = [];
    Object.keys(json.orderRows).map((rowGroupKey) =>
      json.orderRows[rowGroupKey].map((row) => {
        for (const i in products) {
          if (Object.hasOwnProperty.call(products, i) && products[i].articleNumber === row.articleNumber) {
            row.gtmEcommerceItem.quantity = products[i].quantity;
            responseProducts.push(row);
          }
        }
      })
    );

    let gtmProducts = responseProducts.map((prod) => prod.gtmProduct);
    if (gtmProducts) {
      gtmService.pushEcommerce({
        event: 'productImpressions',
        ecommerce: {
          currencyCode: gtmProducts[0].currency,
          add: {
            products: gtmProducts,
          },
        },
      });
    }

    const gtmEcommerceItems = responseProducts.map((prod) => prod.gtmEcommerceItem);
    if (gtmEcommerceItems) {
      gtmService.dataLayerAddToCart(gtmEcommerceItems);
    }
  } catch (error) {
    console.log('error', error);
  }

  return json;
};

export const reorder = async (orderId) => {
  const response = await post('/api/cart/reorder', { orderId });
  return response.json();
};

export const onQuantityInputChange = (
  stateOrderRows,
  tempOrderRows,
  abortController,
  onChange,
  rowGroupKey,
  articleNumber,
  quantity,
  rowSystemId,
  ensureCorrectness
) => {
  // In case of onBlur event, we need ensureCorrectness as true in order to ensure if the value is a valid float number
  // In case of onChange event, we accept invalid float number, but we don't send any request to the server.
  if (abortController) abortController.abort();

  let floatQuantity = parseFloat(quantity);
  let validValue = !isNaN(floatQuantity) && floatQuantity > 0;
  if (ensureCorrectness) {
    quantity = validValue ? floatQuantity : 1;
    floatQuantity = quantity;
    validValue = true;
  }
  const index = tempOrderRows[rowGroupKey].findIndex(
    (item) => item.rowSystemId === rowSystemId
  );
  const oldQuantity = parseFloat(stateOrderRows[rowGroupKey][index].quantity);
  if (floatQuantity !== oldQuantity && validValue) {
    onChange && onChange(articleNumber, quantity, rowSystemId);
  }
  const newTempOrderRows = Object.assign({}, tempOrderRows);
  newTempOrderRows[rowGroupKey][index] = {
    ...newTempOrderRows[rowGroupKey][index],
    quantity,
  };
  return newTempOrderRows;
};
